import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useUser } from './use-user';

export const useAdmin = () => {
  const { user } = useUser();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isStaff, setIsStaff] = useState(false);
  const [isSubAgent, setIsSubAgent] = useState(false);
  const [role, setRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        setIsAdmin(false);
        setIsStaff(false);
        setIsSubAgent(false);
        setRole(null);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('role')
          .eq('user_id', user.id)
          .maybeSingle();

        if (error) {
          console.error('Error checking admin status:', error);
          setIsAdmin(false);
          setIsStaff(false);
          setIsSubAgent(false);
          setRole(null);
        } else if (data) {
          setIsAdmin(data.role === 'admin');
          setIsStaff(data.role === 'admin' || data.role === 'staff');
          setIsSubAgent(data.role === 'sub_agent');
          setRole(data.role ?? null);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
        setIsStaff(false);
        setIsSubAgent(false);
        setRole(null);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  return { isAdmin, isStaff, isSubAgent, role, loading };
};